<template>
  <div class="mt-8 bg-white shadow overflow-hidden rounded-md -mx-4 sm:mx-0">
    <transition-group name="list" tag="ul">
      <li
        v-for="(job, i) in jobs"
        v-bind:key="`${job.companyName}_${i}`"
        v-on:click="(e) => openModal(e, job)"
        :class="i !== 0 ? 'border-t border-gray-200' : ''"
      >
        <a
          class="cursor-pointer block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="sm:flex items-center justify-between">
              <div class="text-md leading-5 font-medium text-indigo-600 truncate">{{job.position}}</div>
              <div class="mt-1 sm:mt-0 sm:ml-2 flex-shrink-0 flex">
                <span
                  v-for="(tag, i) in job.tags.slice(0, 2)"
                  v-bind:key="`${job.company}_${job.position}_${tag}_${i}`"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                  v-on:click="addFilterTag(tag)"
                  :class="{'ml-1': i !== 0}"
                >{{ tag }}</span>
                <span
                  class="ml-1 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                  v-if="job.tags.length > 2"
                >{{ `+ ${job.tags.length - 2 } more`}}</span>
              </div>
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex">
                <div class="mr-6 flex items-center text-sm leading-5 text-gray-500">
                  <svg
                    class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  {{job.companyName}}
                </div>
                <div class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mt-0">
                  <svg
                    class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path
                      d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"
                    />
                  </svg>
                  {{job.source}}
                </div>
              </div>
              <div class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mt-0">
                <svg
                  class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  Posted
                  <time>{{ job.date | diffForHumans }}</time>
                </span>
              </div>
            </div>
          </div>
        </a>
      </li>
    </transition-group>
  </div>
</template>

<script>
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

export default {
  name: "JobList",
  props: {
    jobs: Array,
    openModal: Function
  },
  created() {
    dayjs.extend(relativeTime);
  },
  filters: {
    diffForHumans: date => {
      if (!date) {
        return null;
      }

      return dayjs(date).fromNow();
    }
  }
};
</script>
<style scoped>
ul,
li {
  margin: 0;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.4s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(25px);
}
</style>
